"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/realimpeks",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/realimpeks/",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/real-impeks-d-o-o-",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const t = useTranslations("common");
  const tFooter = useTranslations("footer");
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Description */}
          <div>
            <h2 className="text-lg font-bold mb-4">Real Impeks</h2>
            <p className="text-primary-200 text-sm leading-relaxed mb-4">
              {tFooter("description")}
            </p>
            {/* Social Links */}
            <div>
              <p className="text-sm font-medium text-primary-300 mb-3">{tFooter("followUs")}</p>
              <div className="flex gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 bg-primary-800 hover:bg-primary-700 rounded-lg flex items-center justify-center text-primary-200 hover:text-white transition-colors"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-lg font-bold mb-4">{t("quickLinks")}</h2>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                <li>
                  <Link
                    href="/o-nama"
                    className="text-primary-200 hover:text-white text-sm transition-colors"
                  >
                    {t("about")}
                  </Link>
                </li>
                <li>
                  <Link
                    href="/proizvodi"
                    className="text-primary-200 hover:text-white text-sm transition-colors"
                  >
                    {t("products")}
                  </Link>
                </li>
                <li>
                  <Link
                    href="/usluge"
                    className="text-primary-200 hover:text-white text-sm transition-colors"
                  >
                    {t("services")}
                  </Link>
                </li>
                <li>
                  <Link
                    href="/kontakt"
                    className="text-primary-200 hover:text-white text-sm transition-colors"
                  >
                    {t("contact")}
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Company Info (APR Data) */}
          <div>
            <h2 className="text-lg font-bold mb-4">{tFooter("companyInfo")}</h2>
            <address className="not-italic text-sm text-primary-200 space-y-2">
              <p className="font-medium text-white">{tFooter("companyName")}</p>
              <p>{tFooter("street")}</p>
              <p>{tFooter("city")}</p>
              <p className="pt-2">
                <span className="text-primary-300">{tFooter("taxId")}:</span>
                <br />
                {tFooter("taxIdValue")}
              </p>
              <p>
                <span className="text-primary-300">{tFooter("regNumber")}:</span>
                <br />
                {tFooter("regNumberValue")}
              </p>
            </address>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="text-lg font-bold mb-4">{t("contactInfo")}</h2>
            <address className="not-italic text-sm text-primary-200 space-y-2">
              <p>
                <a href="tel:+38124604150" className="hover:text-white transition-colors">
                  {tFooter("phone")}
                </a>
              </p>
              <p>
                <a href={`mailto:${tFooter("email")}`} className="hover:text-white transition-colors">
                  {tFooter("email")}
                </a>
              </p>
              <p>
                <a
                  href={`https://${tFooter("website")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {tFooter("website")}
                </a>
              </p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-primary-800">
          <div className="text-center text-primary-300 text-sm space-y-1">
            <p>{t("copyright", { year: currentYear })}</p>
            <p>
              {t("poweredBy")}{" "}
              <a
                href="https://www.realproduct.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors underline"
              >
                Real Product
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
